import { render } from "./KidHeader2.vue?vue&type=template&id=02282cec&scoped=true"
import script from "./KidHeader2.vue?vue&type=script&lang=js"
export * from "./KidHeader2.vue?vue&type=script&lang=js"

import "./KidHeader2.vue?vue&type=style&index=0&id=02282cec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02282cec"]])

export default __exports__